export var CreditCardTypesList = [
    {
        id: "AX",
        name: "American Express",
    },
    {
        id: "DC",
        name: "Diners Club",
    },
    {
        id: "DS",
        name: "Discover",
    },
    {
        id: "JC",
        name: "JCB",
    },
    {
        id: "MC",
        name: "Mastercard",
    },
    {
        id: "VI",
        name: "Visa",
    },
];
export var CreditCardTypesMap = CreditCardTypesList.reduce(function (acc, card) {
    acc[card.id] = card;
    return acc;
}, {});
export var CurrencyList = [
    {
        type: "cad",
        symbol: "C$",
        name: "Canadian Dollar",
        iso: "CA",
    },
    {
        type: "usd",
        symbol: "$",
        name: "U.S. Dollar",
        iso: "US",
    },
    {
        type: "aed",
        symbol: "AED",
        name: "Emirati Dirham",
        iso: "AE",
    },
    {
        type: "aud",
        symbol: "AU$",
        name: "Australian Dollar",
        iso: "AU",
    },
    {
        type: "brl",
        symbol: "R$",
        name: "Brazilian Real",
        iso: "BR",
    },
    {
        type: "cny",
        symbol: "¥",
        name: "Chinese Yuan Renminbi",
        iso: "CN",
    },
    {
        type: "dkk",
        symbol: "kr",
        name: "Danish Krone",
        iso: "DK",
    },
    {
        type: "eur",
        symbol: "€",
        name: "Euro",
        iso: "DE",
    },
    {
        type: "gbp",
        symbol: "£",
        name: "Pound Sterling",
        iso: "GB",
    },
    {
        type: "hkd",
        symbol: "HK$",
        name: "Hong Kong Dollar",
        iso: "HK",
    },
    {
        type: "inr",
        symbol: "₹",
        name: "Indian Rupee",
        iso: "IN",
    },
    {
        type: "mxn",
        symbol: "MX$",
        name: "Mexican Peso",
        iso: "MX",
    },
    {
        type: "myr",
        symbol: "RM",
        name: "Malaysian Ringgit",
        iso: "MY",
    },
    {
        type: "nzd",
        symbol: "NZ$",
        name: "New Zealand dollar",
        iso: "NZ",
    },
    {
        type: "php",
        symbol: "₱",
        name: "Philippine Peso",
        iso: "PH",
    },
    /*{
      type: "rub",
      symbol: "₽",
      name: "Russian Ruble",
      iso: "RU",
    },*/
    {
        type: "sgd",
        symbol: "S$",
        name: "Singapore Dollar",
        iso: "SG",
    },
    {
        type: "thb",
        symbol: "฿",
        name: "Thai Baht",
        iso: "TH",
    },
    {
        type: "twd",
        symbol: "NT$",
        name: "Taiwan New Dollar",
        iso: "TW",
    },
];
export var CurrencyMap = CurrencyList.reduce(function (acc, currency) {
    acc[currency.type] = currency;
    return acc;
}, {});
